import { CmsInstallationInstructionPanel } from '../../models/registration-confirmation/cms-installation-instruction-panel.interface';

export const mockCmsInstallationInstructionPanel: CmsInstallationInstructionPanel =
  {
    installationInstructionPanelBody: 'Important note:',
    installationInstructionPanelTitle:
      'Make sure to remove the transit bolts and the supporting polystyrene block from your new Washing Machine or Washer Dryer before use.',
  };
